import SimulationProcessData from './SimulationProcessData';

function SimulationDeployed(
    chartType: RulePerformanceChartType,
    formValues?: ProcessedSimulationReportFormValues,
    totalTransactions?: number,
    compareData?: SimulationQueryResponse,
    deployedResultSet?: SimulationResultSet
) {
    const countResult = compareData?.countResult;
    const pivotCount = countResult && countResult.resultSet?.tablePivot();
    const deployedData: SimulationPerformanceTableItem[] = [];
    let deployedRejectedTransactions = 0;
    const deployedProcessedData = SimulationProcessData(deployedResultSet, totalTransactions, chartType, formValues);
    if (countResult && countResult.isLoading) {
        return {
            deployedData,
            deployedRejectedTransactions,
            deployedTotalRejectedMatches: deployedProcessedData?.totalRejectedMatches
        };
    }

    if (pivotCount?.length) {
        deployedRejectedTransactions = Number(pivotCount[0]['SimulationTpp.uniqueRejectedCount']);
    }

    return {
        deployedData: deployedProcessedData?.processedData,
        deployedRejectedTransactions,
        deployedTotalRejectedMatches: deployedProcessedData?.totalRejectedMatches
    };
}
export default SimulationDeployed;
